(function () {
	'use strict';

	angular.module('gatewayApp').controller('HomeBranchDialogController',
		HomeBranchDialogController);

	HomeBranchDialogController.$inject = ['$scope', '$state', '$rootScope',
		'GlobalValues', 'workflowSharedService', '$uibModalInstance',
		'ManageHomeBranch', 'entity', 'DateUtils', 'AlertService', '$filter', 'StaticLookUp', 'BankRegistration'];

	function HomeBranchDialogController($scope, $state, $rootScope, GlobalValues,
		workflowSharedService, $uibModalInstance, ManageHomeBranch, entity, DateUtils, AlertService, $filter, StaticLookUp, BankRegistration) {
		var vm = this;
		vm.homeBranch = entity;
		vm.homeBranchDetailsDTO = {};
		//vm.ifscOrSwift = 'IFSC';
		vm.numberOfDigits = 11;
		//vm.openSearchHomeBranch = openSearchBranch;
		vm.ExpandOrCollapseBankDetails = true;
		vm.clear = clear;
		vm.save = save;
		vm.clicked = false;
		$scope.showButton = false;
		vm.resubmitHomeBranch = resubmitHomeBranch;
		vm.globalValues = GlobalValues;
		//vm.branch.country=vm.globalValues.getCountry();
		vm.todayDate = new Date();
		vm.valid = true;
		vm.bank = null;
		vm.stateName = null;
		vm.disablemode = false;
		vm.errorText = null;
		// vm.isEditMode = !!(vm.homeBranch && vm.homeBranch.id);
		vm.entityOwnerType = vm.globalValues.getUser().entityOwnerType.shortName;

		if (workflowSharedService.viewFrom == 'homeBranch') {
			vm.homeBranch = entity;
			if (vm.homeBranch != null && vm.homeBranch.id != null) {
				setBankValue();
				vm.homeBranchCounty = vm.globalValues.getCountry();
				// setStateValue();
				//do nothing
			} else {
				vm.homeBranchCounty = vm.globalValues.getCountry();
			}
			vm.homeBranch.bank = vm.globalValues.getBank();
			if(vm.homeBranch.bank != null && vm.homeBranch.bankName != null){
			preparDeliveryModeDTOList(vm.homeBranch);
			}
			$scope.showButton = false;
		} else if (workflowSharedService.viewFrom == 'homebranchtodolist_resubmit') {
			// 	vm.homeBranchDTO = angular.fromJson($rootScope.payload);
			vm.homeBranchDetailsDTO = angular.fromJson($rootScope.payload);
			if (vm.homeBranch == undefined) {
				vm.homeBranch = vm.homeBranchDetailsDTO
			}
			setBankValue();
			setStateValue();
			preparDeliveryModeDTOList(vm.homeBranch);
			vm.homeBranchCounty = vm.globalValues.getCountry();
			vm.disableForm = false;
			vm.disablemode = true;
			$scope.showButton = true;
		} else if (workflowSharedService.viewFrom == 'home_branch_resubmit_delete') {
			vm.homeBranch = angular.fromJson($rootScope.payload);
			setBankValue();
			setStateValue();
			preparDeliveryModeDTOList(vm.homeBranch);
			vm.disableForm = true;
			$scope.showButton = true;
		}

		function convertBooleanToYesNo(value) {
			if (value || value == false) return value;
			return value == 'yes' ? true : (value == 'no' ? false : null);
		}



		function validateEmail(email) {
			var re = /^([\w-]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$/i;
			return re.test(email);
		}

		function testEmailValidation(email) {

			if (vm.homeBranch.homeBranchEmailId != null && vm.homeBranch.homeBranchEmailId != undefined && vm.homeBranch.homeBranchEmailId != '') {
				var emails = email.split(';');

				vm.invalidEmails = [];

				for (var i = 0; i < emails.length; i++) {
					if (!validateEmail(emails[i].trim())) {
						vm.invalidEmails.push(emails[i].trim())
					}
				}

				if (vm.invalidEmails.length > 0) {

					vm.valid = false;
				} else {
					vm.valid = true;
				}

			}
			else {
				vm.valid = true;
			}
		}
		function setBankValue() {
			if (vm.homeBranch.bankName != null) {
				BankRegistration.getBankForShortName({ bankName: vm.homeBranch.bankName }, function (result) {
					vm.bank = result;
					vm.homeBranch.bank = result;
				});
			}
		}
		function setStateValue() {

			if (vm.homeBranch.state != null) {
				StaticLookUp.getStateobject({ stateName: vm.homeBranch.state }, function (result) {
					vm.homeBranch.stateObject = result;
				})
			}
		}
		function clear() {
			$uibModalInstance.dismiss('cancel');
		}
		function save() {
			vm.homeBranch.aliasName = vm.homeBranch.bankName;
			vm.homeBranch.shortName = vm.homeBranch.bankName;
			vm.homeBranch.bankName = vm.homeBranch.bank.bankName;
			if (vm.bank != null) {
				vm.homeBranch.bankName = vm.bank.bankName;
			}
			if (vm.homeBranch.stateObject != null) {
				vm.homeBranch.state = vm.homeBranch.stateObject.shortName;
			}
			setDeliveryMode();
			vm.homeBranchDetailsDTO = vm.homeBranch;

			testEmailValidation(vm.homeBranch.homeBranchEmailId);
			if (vm.valid == true) {
				if (vm.homeBranch.id !== null) {
					ManageHomeBranch.update({
						"corpId": GlobalValues.getCorpId()
					}, vm.homeBranch, onSaveSuccess, onSaveError);
				} else if (vm.valid == true) {
					ManageHomeBranch.save({
						"corpId": GlobalValues.getCorpId()
					}, vm.homeBranchDetailsDTO, onSaveSuccess, onSaveError);
				}
			} else {
				var error = $filter('translate')('gatewayApp.homeBranch.invalidEmail');
				AlertService.error(error + vm.invalidEmails);
				vm.clicked = false;
				//AlertService.error($filter('translate')('gatewayApp.emailSettings.invalidEmail'),invalidEmails);
			}

		}

		function onSaveSuccess(result) {
			$uibModalInstance.close(result);
			vm.clicked = false;
		}

		function onSaveError() {
			vm.clicked = false;
		}



		function resubmitHomeBranch() {


			vm.homeBranch.aliasName = vm.homeBranch.bankName;
			vm.homeBranch.shortName = vm.homeBranch.bankName;
			vm.homeBranch.bankName = vm.homeBranch.bank.bankName;
			if (vm.bank != null) {
				vm.homeBranch.bankName = vm.bank.bankName;
			}
			if (vm.homeBranch.stateObject != null) {
				vm.homeBranch.state = vm.homeBranch.stateObject.shortName;
			}
			setDeliveryMode();
			vm.homeBranchDetailsDTO = vm.homeBranch;

			testEmailValidation(vm.homeBranch.homeBranchEmailId);
			if (vm.valid == true) {
				if (vm.homeBranch.id == null) {
					ManageHomeBranch.resubmitForCreate({
						"taskId": $rootScope.taskID
					}, vm.homeBranchDetailsDTO, onResubmitSuccess, onResubmitError);
				} else {
					ManageHomeBranch.resubmitForEdit({
						"taskId": $rootScope.taskID
					}, vm.homeBranch, onResubmitSuccess, onResubmitError);
				}
			} else {
				var error = $filter('translate')('gatewayApp.homeBranch.invalidEmail');
				AlertService.error(error + vm.invalidEmails);
				//AlertService.error($filter('translate')('gatewayApp.emailSettings.invalidEmail'),invalidEmails);
				vm.clicked = false;
			}

		}

		function onResubmitSuccess(result) {
			$rootScope.removeRow($rootScope.taskID);
			$uibModalInstance.dismiss('cancel');
		}
		function onResubmitError(error) {
			vm.clicked = false;
		}


		function preparDeliveryModeDTOList(homeBranch) {
			if(vm.homeBranch.bankName != null && vm.homeBranch.bankName !=undefined){
			getCurrencyPairList(vm.homeBranch.bankName);
			}else{
				getCurrencyPairList(vm.homeBranch.bank.bankName);
			}
			
			prepardeliveryModeIsEnable(homeBranch);
			vm.forexCardLoad = homeBranch.forexCardLoad ? homeBranch.forexCardLoad.split(",") : [];
			vm.currencyNotes = homeBranch.currencyNotes ? homeBranch.currencyNotes.split(",") : [];
			vm.remittance = homeBranch.remittance ? homeBranch.remittance.split(",") : [];
			vm.forexCardIssuance = homeBranch.forexCardIssuance ? homeBranch.forexCardIssuance.split(",") : [];
		}

		function preparDeliveryModeList(currencyPairList, deliveryMode) {

			var deliveryModeMap = {};

			angular.forEach(deliveryMode, function (code) {
				deliveryModeMap[code] = true;
			});

			return currencyPairList.map(function (item) {
				return {
					CurrencyCode: item.baseCurrency.code,
					isEnable: !!deliveryModeMap[item.baseCurrency.code]
				};
			});
		}



		function getCurrencyPairList(bankName) {

			StaticLookUp.getCurrencyPairBankName({ "bankName": bankName }, getCurrencyPairSuccess, getCurrencyPairError);
		}

		function getCurrencyPairSuccess(result) {
			vm.currencyPairList = result

			vm.forexCardLoadList = preparDeliveryModeList(vm.currencyPairList, vm.forexCardLoad);
			vm.currencyNoteList = preparDeliveryModeList(vm.currencyPairList, vm.currencyNotes);
			vm.remittanceList = preparDeliveryModeList(vm.currencyPairList, vm.remittance);
			vm.forexCardIssuanceList = preparDeliveryModeList(vm.currencyPairList, vm.forexCardIssuance);
		}
		function getCurrencyPairError() { }

		function setDeliveryMode() {
			vm.homeBranch.currencyNotes = convertDeliveryModeToString(vm.currencyNoteList,vm.homeBranch.currencyNotesIsEnable);
			vm.homeBranch.forexCardLoad = convertDeliveryModeToString(vm.forexCardLoadList,vm.homeBranch.forexCardLoadIsEnable);
			vm.homeBranch.remittance = convertDeliveryModeToString(vm.remittanceList,vm.homeBranch.remittanceIsEnable);
			vm.homeBranch.forexCardIssuance = convertDeliveryModeToString(vm.forexCardIssuanceList,vm.homeBranch.forexCardIssuanceIsEnable);
		}


		function convertDeliveryModeToString(deliveryModeList,deliveryModeIsEnable) {
			var currency = "";
			angular.forEach(deliveryModeList, function (item) {
				if(deliveryModeIsEnable){
				if (item.isEnable) {
					if (currency) {
						currency += ",";
					}
					currency += item.CurrencyCode;
				}
			}
			});
			return currency;
		}

		function prepardeliveryModeIsEnable(homeBranch) {
			vm.homeBranch.currencyNotesIsEnable = homeBranch.currencyNotes != null && homeBranch.currencyNotes !='';
			vm.homeBranch.forexCardLoadIsEnable = homeBranch.forexCardLoad != null && homeBranch.forexCardLoad !='';
			vm.homeBranch.remittanceIsEnable = homeBranch.remittance != null && homeBranch.remittance !='';
			vm.homeBranch.forexCardIssuanceIsEnable = homeBranch.forexCardIssuance != null && homeBranch.forexCardIssuance !='';
			
		}

		$scope.$watch('vm.homeBranch.bank', function(value){
        	if(value!=null && value!=undefined){
			vm.homeBranch.bankName = value.bankName;
			 vm.errorText = null;
 			preparDeliveryModeDTOList(vm.homeBranch)
        	}else{
				vm.homeBranch.bankName=null;
				vm.homeBranch.currencyNotesIsEnable=null;
				vm.homeBranch.forexCardLoadIsEnable=null;
				vm.homeBranch.remittanceIsEnable =null;
				vm.homeBranch.forexCardIssuanceIsEnable=null;
			}
        })	

		 $scope.$watchGroup(['vm.homeBranch.currencyNotesIsEnable', 'vm.homeBranch.forexCardLoadIsEnable', 'vm.homeBranch.remittanceIsEnable', 'vm.homeBranch.forexCardIssuanceIsEnable'], function (value) {
			if(vm.homeBranch.bankName == null || vm.homeBranch.bankName == undefined){	
				vm.errorText ='kindly select the bank';
			} else{
				vm.errorText = null;
			}


			})

	}
})();
